import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import { useLanguage } from '../i18n/LanguageContext';
import './Projects.css';

const Projects = () => {
  const { t } = useLanguage();
  const items = t('projects.items');

  return (
    <section className="projects section" id="projects">
      <div className="container">
        <motion.div
          className="projects__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">{t('projects.label')}</span>
          <h2 className="section-title">
            {t('projects.titleStart')}
            <span className="gradient-text">{t('projects.titleHighlight')}</span>
          </h2>
          <p className="section-subtitle">{t('projects.subtitle')}</p>
        </motion.div>

        <div className="projects__grid">
          {items.map((project, i) => (
            <motion.div
              key={project.id}
              className="projects__card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.08 * i, duration: 0.5 }}
              whileHover={{ y: -6 }}
            >
              <div className="projects__card-image">
                {project.image ? (
                  <img src={project.image} alt={project.title} />
                ) : (
                  <div className="projects__card-placeholder">
                    <span>{project.title.charAt(0)}</span>
                  </div>
                )}
                {project.badge && (
                  <span className="projects__card-badge">
                    {t(`projects.${project.badge}`)}
                  </span>
                )}
              </div>
              <div className="projects__card-body">
                <h3 className="projects__card-title">{project.title}</h3>
                <Link
                  to={`/projects#${project.id}`}
                  className="projects__card-link"
                >
                  {t('projects.viewProject')} <HiArrowRight />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="projects__view-all"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <Link to="/projects" className="projects__view-all-link">
            {t('projects.viewAll')} <HiArrowRight />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
